<template>
  <div class="container-margin">
    <v-row>
      <v-col cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col class="title-big-home custom-margin-first-title">
                <img class="custom-shape-red" src="@/assets/red-dots.png" alt="red-dots">
                <img class="custom-shape-circle-red" src="@/assets/shape-02.png" alt="red-circle">
                <img class="custom-shape-green" src="@/assets/some-point.png" alt="green-dots">
                <img class="custom-shape-line" src="@/assets/line-shape.png" alt="green-dots">
                <img alt="dorakk" src="@/assets/dorakk-logo.png" class="dorak-logo"/>
                آموزش موسیقی
              </v-col>
              <v-col>
                <img src="@/assets/index1.png" alt="index">
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="6">
            <img v-if="!showVideo" @click="showVideo = true" src="@/assets/play.png" class="play-image" width="30%"
                 alt="index">
            <video autoplay controls v-if="showVideo" class="play-video" src="@/assets/video-inter.mp4"></video>
          </v-col>
          <v-col cols="6">
            <div class="dorak-description-big">یکی از دوره های آموزشی دُرَک، دوره آشنایی با ریتم برای کودکان است</div>
            <div class="dorak-description-small">برای دیدن ویدیو کلیپ روی تصویر کلیک کنید</div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-center text-description-using">برای استفاده از دوره های آموزشی ابتدا باید
        <a @click="$router.push('/register')">عضو</a>
        شوید
      </v-col>
      <v-col cols="12" class="text-center text-courses-title">دوره های آموزشی</v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="4" v-for="course in courses" :key="course.id">
            <v-card>
              {{ course }}
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="footer-container">
        <v-row>
          <v-col cols="4" class="text-center">
            <v-text-field placeholder="مشاوره می خواهید ؟ شماره خود را وارد کنید." class="news-text-field"
                          background-color="white" color="white" outlined append-outer-icon="mdi-phone">
            </v-text-field>
            <v-btn class="submit-register-news" fab elevation="0" small>
              <v-icon color="#1ab69d">mdi-check</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="4" class="text-center">
            <img class="dorakk-logo-footer" src="@/assets/dorakk-footer-logo.png" alt="">
          </v-col>
          <v-col cols="4" class="pt-16">
            <v-row>
              <v-col cols="12" class="white--text">
                <span class="footer-link">
                  <v-icon class="footer-circle-icon" color="white">mdi-circle-outline</v-icon>
                  درباره دُرَک
                </span>
              </v-col>
              <v-col cols="12" class="white--text">
                <span class="footer-link">
                  <v-icon class="footer-circle-icon" color="white">mdi-circle-outline</v-icon>
                  تماس با دُرَک
                </span>
              </v-col>
              <v-col cols="12" class="white--text">
                <span class="footer-link">
                  <v-icon class="footer-circle-icon" color="white">mdi-circle-outline</v-icon>
                  بلاگ
                </span>
              </v-col>
              <v-col cols="12" class="white--text">
                <span class="footer-link">
                  <v-icon class="footer-circle-icon" color="white">mdi-circle-outline</v-icon>
                  همکاری با دُرَک
                </span>
              </v-col>
              <v-col cols="12">
                <v-icon large class="mx-2 footer-link" color="white">mdi-instagram</v-icon>
                <v-icon large class="mx-2 footer-link" color="white">mdi-twitter</v-icon>
                <v-icon large class="mx-2 footer-link" color="white">mdi-facebook</v-icon>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'HomeTablet',
  data() {
    return {
      showVideo: false,
      courses: []
    }
  }
}
</script>
<style>
.container-margin {
  margin: -1vh 0 8vw 8vw;
}

.title-big-home {
  font-size: 2.7vw !important;
  color: black;
}

.custom-margin-first-title {
  margin-top: 15vh !important;
  margin-right: 15vw !important;
}

.dorak-logo {
  position: absolute;
  top: 27vh;
  animation-name: dorak-logo;
  animation-duration: 6s;
  animation-iteration-count: infinite;
}

@keyframes dorak-logo {
  0% {
    transform: rotate(-5deg)
  }
  50% {
    transform: rotate(5deg)
  }
  100% {
    transform: rotate(-5deg)
  }
}

.custom-shape-red {
  z-index: 2;
  position: absolute;
  top: 25vh;
  animation-name: shape-dot-red;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

@keyframes shape-dot-red {
  0% {
    transform: rotate(-5deg)
  }
  50% {
    top: 21vh
  }
  100% {
    top: 25vh
  }
}

.custom-shape-circle-red {
  position: absolute;
  top: 8vh;
  right: 14vw;
  animation-name: shape-circle-red;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

@keyframes shape-circle-red {
  0% {
    transform: rotate(-5deg)
  }
  50% {
    right: 13vw;
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(-5deg);
  }
}

.custom-shape-green {
  z-index: 2;
  position: absolute;
  top: 25vh;
  animation-name: shape-dot-green;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

@keyframes shape-dot-green {
  0% {
    transform: rotate(-5deg)
  }
  50% {
    top: 29vh
  }
  100% {
    top: 25vh
  }
}

.custom-shape-line {
  position: absolute;
  top: 34vh;
  right: 54vw;
  animation-name: shape-line-green;
  animation-duration: 8s;
  animation-iteration-count: infinite;
}

@keyframes shape-line-green {
  0% {
    transform: rotate(-5deg)
  }
  50% {
    right: 50vw;
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(-5deg);
  }
}

.dorak-description-small {
  font-size: 1vw !important;
  color: black;
}

.dorak-description-big {
  font-size: 1.5vw !important;
  color: black;
}

.play-image {
  position: absolute;
  z-index: 2;
  right: 12vw;
  top: 60vh;
}

.play-image:hover {
  transform: rotate(-2deg);
}

.play-video {
  width: 30%;
  position: absolute;
  z-index: 2;
  right: 12vw;
  top: 60vh;
}

.text-description-using {
  margin-top: 20vh;
  font-size: 1.3vw;
  color: black;
  margin-right: 5vw;
}

.text-courses-title {
  font-size: 2vw;
  color: black;
  margin-right: 5vw;
}

.footer-container {
  position: absolute;
  top: 145vh;
  bottom: 0;
  left: 0;
  height: 450px;
  background-color: black;
  background-image: url("/src/assets/footer-bg.webp");
    border-radius: 5px 5px 0 0;

}

.dorakk-logo-footer {
  animation-name: dorakk-footer-logo;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes dorakk-footer-logo {
  0% {
    transform: rotate(-1deg)
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-1deg);
  }
}

.footer-link {
  cursor: pointer;
}

.footer-link:hover {
  transform: rotate(45deg) !important;
  color: #1ab69d !important;
}

.news-text-field {
  width: 60%;
  right: 14vw;
  bottom: -10vh;
}

.submit-register-news {
  right: -2.5vw;
  animation-name: submit-button-news;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes submit-button-news {
  0% {
    transform: rotate(-30deg)
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(-30deg);
  }
}

.footer-circle-icon:hover {
  color: #1ab69d !important;
}
</style>